<template lang="pug">
    v-form.c-form(autocomplete="off")

        // Full Name field
        v-text-field(
            :error-messages="errors.collect('fullName')"
            :data-vv-as="$t('fields.fullName')"
            :label="$t('fields.fullName')"
            name="fullName"
            v-model="model.fullName"
            v-validate="'required|min:2|max:72'"
            outline
        )

        // Contact Email field
        v-text-field(
            :error-messages="errors.collect('email')"
            :data-vv-as="$t('fields.email')"
            :label="$t('fields.email')"
            name="email"
            type="email"
            v-model.lazy="model.email"
            v-validate="'required|email'"
            outline
        )

        // Contact Phone field
        v-text-field(
            :error-messages="errors.collect('phone')"
            :data-vv-as="$t('fields.phone')"
            :label="$t('fields.phone')"
            name="phone"
            v-model.lazy="model.phone"
            v-validate="'required|min:6'"
            mask="###-###-######-####"
            outline
        )

        // City field
        v-text-field(
            :error-messages="errors.collect('city')"
            :data-vv-as="$t('fields.city')"
            :label="$t('fields.city')"
            name="city"
            v-model="model.city"
            v-validate="'min:2|max:100'"
            outline
        )

        // State field
        v-text-field(
            :error-messages="errors.collect('state')"
            :data-vv-as="$t('fields.state')"
            :label="$t('fields.state')"
            name="state"
            v-model="model.state"
            v-validate="'min:2|max:100'"
            outline
        )

        // State field
        v-text-field(
            :error-messages="errors.collect('country')"
            :data-vv-as="$t('fields.country')"
            :label="$t('fields.country')"
            name="country"
            v-model="model.country"
            v-validate="'min:2|max:100'"
            outline
        )

        // Dept field
        v-text-field(
            :error-messages="errors.collect('department')"
            :data-vv-as="$t('fields.department')"
            :label="$t('fields.department')"
            name="department"
            v-model="model.department"
            v-if="model.business && model.business.maxUsers >= 15"
            v-validate="'min:2|max:100'"
            outline
        )

        div(v-if="customFields && customFields.length")

            div(
                v-for="(item, key) in customFields"
                :key="key"
            )

                // Company Size
                v-select(
                    v-if="item.label === 'businessSize'"
                    :items="$t('selection.companySizes')"
                    :label="$t('fields.organizationSize')"
                    name="companySize"
                    v-model="customFields[key].value"
                    append-icon="expand_more"
                    outline
                    v-validate="'required'"
                    :data-vv-as="$t('fields.companySize')"
                    :error-messages="errors.collect('companySize')"
                )

                // Custom fields
                v-text-field(
                    v-else
                    :error-messages="errors.collect(`custom-field-${key}`)"
                    :data-vv-as="toFieldName(item.label)"
                    :label="toFieldName(item.label)"
                    :name="`custom-field-${key}`"
                    v-model="customFields[key].value"
                    v-validate="customValidation(customFields[key])"
                    outline
                )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import startCase from 'lodash/startCase';

    export default {
        $_veeValidate: {
            validator: 'new',
            companySize: ''
        },
        computed: {
            ...mapFields('users', {
                model: 'user'
            }),
            ...mapGetters('auth', ['isAdmin', 'isChampion']),

            customFields: function() {
                let customFields;
                if (
                    this.model.business &&
                    this.model.business.customFields &&
                    this.model.business.customFields.length
                ) {
                    customFields = this.model.business.customFields;
                } else {
                    customFields = [];
                }

                if (
                    customFields &&
                    customFields.length &&
                    this.model.additionalInformation
                ) {
                    customFields.forEach((elem, index) => {
                        const data = this.model.additionalInformation.find(
                            data => data.field.id === elem.id
                        );

                        if (data) {
                            customFields[index].value = data.value;
                        } else {
                            customFields[index].value = '';
                        }
                    });
                }

                return customFields;
            }
        },
        methods: {
            ...mapActions('users', ['update']),

            /**
             * Validation for custom fields
             */
            customValidation(field) {
                let validation = '';

                if (field.isRequired) {
                    validation = 'required|';
                }
                if (field.type !== 'string') {
                    validation += 'numeric';
                }

                return validation;
            },

            /**
             * Create business on submit
             * @returns {boolean}
             */
            async submitForm() {
                // Validate all fields
                const validation = await this.$validator.validateAll();

                // Check validation pass
                if (!validation) return;

                // Set custom fields for update
                this.customFields.map(elem => {
                    this.model[elem.label] =
                        elem.type === 'string' ? elem.value : +elem.value;
                });

                // Call store action
                this.update();
            },

            /**
             * Custom field name
             * @param {string} key
             * @returns {string}
             */
            fieldName(key) {
                return `fieldTitle-${key}`;
            },

            /**
             * Transform camel case to field name
             * @param {string} label
             */
            toFieldName(label) {
                return startCase(label);
            }
        }
    };
</script>

<style lang="stylus" scoped></style>
